import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Input,
  FormFeedback,
} from 'reactstrap';
import {
  postApprovePostpaidBooking,
  replacePostpaidBooking,
  patchPostpaidBookingVoucherCode,
} from '../../../../actions';
import { POST } from '../../../../config/permissions';
import { generateApprovePostpaidBookingEndpoint } from '../../../../config/endpoints';
import withEndpointAuthorization from '../../../units/authorization/withEndPointAuthorization';
import Loader from '../../Loader';
import { TRANSACTION_TYPE_BANK_TRANSFER } from '../../../../config/constants';

class ApprovePostpaidBookingCell extends Component {
  static propTypes = {
    customerOrderId: PropTypes.number.isRequired,
    transactionCode: PropTypes.string.isRequired,
    dispatchPostApprovePostpaidBooking: PropTypes.func.isRequired,
    dispatchReplacePostpaidBooking: PropTypes.func.isRequired,
    dispatchPatchPostpaidBookingVoucherCode: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    bankAccounts: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.number,
      }),
    ).isRequired,
  };

  state = {
    showApproveModal: false,
    showOperationNumber: false,
    operationNumber: '',
    bankAccount: null,
    validOperationNumber: true,
    depositDate: '',
    validDepositDate: true,
  };

  handleApprovePostpaidBooking = () => {
    const { transactionCode } = this.props;
    if (transactionCode === TRANSACTION_TYPE_BANK_TRANSFER) {
      this.setState({ showOperationNumber: true });
    }
    this.showApproveModal();
  };

  handleBankAccountChange = (value) => {
    this.setState({ bankAccount: value });
  };

  handleOperationNumberChange = (event) => {
    const { value } = event.target;
    this.setState({
      operationNumber: value,
      validOperationNumber: Boolean(value && value.length),
    });
  };

  handleDepositDateChange = (event) => {
    const { value } = event.target;
    this.setState({
      depositDate: value,
      validDepositDate: Boolean(value && value.length),
    });
  };

  sendOperationNumber = async () => {
    const { operationNumber, bankAccount, depositDate } = this.state;
    if (operationNumber && operationNumber.length) {
      this.closeApproveModal();
      const { customerOrderId, dispatchPatchPostpaidBookingVoucherCode } =
        this.props;
      const response = await dispatchPatchPostpaidBookingVoucherCode({
        customerOrderId,
        voucherCode: operationNumber,
        bankAccountId: bankAccount.value,
        depositDate,
      });
      if (response) {
        this.approvePostpaidBooking();
      }
    } else {
      this.setState({ validOperationNumber: false });
    }
  };

  approvePostpaidBooking = async () => {
    this.closeApproveModal();
    const {
      customerOrderId,
      dispatchPostApprovePostpaidBooking,
      dispatchReplacePostpaidBooking,
    } = this.props;
    const postpaidBooking = await dispatchPostApprovePostpaidBooking({
      customerOrderId,
    });
    if (postpaidBooking) {
      dispatchReplacePostpaidBooking({ postpaidBooking });
    }
  };

  showApproveModal = () => {
    this.setState({ showApproveModal: true });
  };

  closeApproveModal = () => {
    this.setState({ showApproveModal: false });
  };

  render() {
    const { loading } = this.props;

    const { showOperationNumber } = this.state;

    let approveModalContent;

    if (loading) {
      approveModalContent = <Loader />;
    } else if (showOperationNumber) {
      approveModalContent = (
        <>
          <ModalBody>
            <Row>
              <Col xs={4}>
                <b>Cuenta bancaria:</b>
              </Col>
              <Col xs={8}>
                <Input
                  type="select"
                  value={
                    this.state.bankAccount ? this.state.bankAccount.value : ''
                  }
                  onChange={(e) => {
                    const selected = this.props.bankAccounts.find(
                      (acc) => acc.value === Number(e.target.value),
                    );
                    this.setState({ bankAccount: selected });
                  }}
                  invalid={!this.state.bankAccount}
                >
                  <option value="">Seleccione una cuenta bancaria</option>
                  {this.props.bankAccounts.map((acc) => (
                    <option key={acc.value} value={acc.value}>
                      {acc.label}
                    </option>
                  ))}
                </Input>
                {!this.state.bankAccount && (
                  <div className="invalid-feedback d-block">
                    Seleccione una cuenta bancaria
                  </div>
                )}
              </Col>
            </Row>

            <br />

            <Row>
              <Col xs={4}>
                <b>Número de operación:</b>
              </Col>
              <Col xs={8}>
                <Input
                  type="text"
                  value={this.state.operationNumber}
                  onChange={this.handleOperationNumberChange}
                  invalid={!this.state.validOperationNumber}
                />
                <FormFeedback>Ingrese un número de operación</FormFeedback>
              </Col>
            </Row>

            <Row>
              <Col xs={4}>
                <b>Fecha de depósito:</b>
              </Col>
              <Col xs={8}>
                <Input
                  type="date"
                  value={this.state.depositDate}
                  onChange={this.handleDepositDateChange}
                  invalid={!this.state.validDepositDate}
                />
                <FormFeedback>Ingrese la fecha de depósito</FormFeedback>
              </Col>
            </Row>
          </ModalBody>

          <ModalFooter>
            <Button color="primary" onClick={this.sendOperationNumber}>
              OK
            </Button>{' '}
            <Button color="secondary" onClick={this.closeApproveModal}>
              Cerrar
            </Button>
          </ModalFooter>
        </>
      );
    } else {
      approveModalContent = (
        <>
          <ModalBody>
            Esta acción aprobará la reserva. ¿Desea continuar?
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.approvePostpaidBooking}>
              OK
            </Button>{' '}
            <Button color="secondary" onClick={this.closeApproveModal}>
              Cerrar
            </Button>
          </ModalFooter>
        </>
      );
    }

    const approveModal = (
      <Modal isOpen={this.state.showApproveModal}>
        <ModalHeader>Confirmación</ModalHeader>
        {approveModalContent}
      </Modal>
    );

    return (
      <>
        <i
          tabIndex="0"
          role="button"
          className="fa fa-check-circle text-success"
          onKeyPress={this.handleApprovePostpaidBooking}
          onClick={this.handleApprovePostpaidBooking}
        />
        {approveModal}
      </>
    );
  }
}

const mapStateToProps = ({ PostpaidBookingUnit, AccountingUnit }) => ({
  loading: PostpaidBookingUnit.PostpaidBooking.getIn(['all', 'activity']),
  bankAccounts: AccountingUnit.BankAccount.getIn([
    'all',
    'content',
    'content',
  ]).map((bankAccount) => ({
    value: bankAccount.id,
    label: `${bankAccount.bank.name} - ${bankAccount.accountNumber}`,
  })),
});

const mapDispatchToprops = {
  dispatchPostApprovePostpaidBooking: postApprovePostpaidBooking,
  dispatchReplacePostpaidBooking: replacePostpaidBooking,
  dispatchPatchPostpaidBookingVoucherCode: patchPostpaidBookingVoucherCode,
};

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToprops,
)(ApprovePostpaidBookingCell);

export default withEndpointAuthorization({
  url: generateApprovePostpaidBookingEndpoint(),
  mapUrlParamsToProps: { customerOrderId: 'customerOrderId' },
  permissionType: POST,
})(connectedComponent);
